import { render, staticRenderFns } from "./NavbarUserDropdown.vue?vue&type=template&id=39caf526&scoped=true"
import script from "./NavbarUserDropdown.vue?vue&type=script&lang=js"
export * from "./NavbarUserDropdown.vue?vue&type=script&lang=js"
import style0 from "./NavbarUserDropdown.vue?vue&type=style&index=0&id=39caf526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39caf526",
  null
  
)

export default component.exports